<template>
    <div class="temp1">
        temp1
    </div>
</template>
<script>
    export default{
        name:'temp1',
        data(){
            return {}
        }
    }
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/main-content/router-test/temp1.vue